export default function fuzzy(items, key, keyword) {
  return items.filter((item) => {
    return item[key].toLowerCase().includes(keyword.toLowerCase())
  })
}
